module.exports = __webpack_public_path__ + "assets/c2m-logo.007ed2e6.svg";